import { render, staticRenderFns } from "./CardCompra.vue?vue&type=template&id=45b631e8"
import script from "./CardCompra.vue?vue&type=script&lang=js"
export * from "./CardCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports